<template>
  <div-box>
    <nav-bar left-arrow :title="$t('我的理财')" />
    <vant-up-down ref="list" @list="(val) => (list = val)" res="res.data.data" :noToken="false"
      url="/api/v1/user/financial" :data="{ status: active + 1 }">
      <div-width width='60vw'>
        <div-tab tab='stick'>
          <van-tabs @click="onClick" v-model='active' background="#0F0F0F" color='#CEB082'>
            <van-tab>
              <template #title>
                <div-padding>
                  <div-text size='4vw' :color='active == 0 ? `#fff` : `#999`'>{{ $t('理财中') }}</div-text>
                </div-padding>
              </template>
            </van-tab>
            <van-tab>
              <template #title>
                <div-padding>
                  <div-text size='4vw' :color='active == 1 ? `#fff` : `#999`'>{{ $t('已结束') }}</div-text>
                </div-padding>
              </template>
            </van-tab>
          </van-tabs>
        </div-tab>
      </div-width>
      <div-padding padding="3vw">
        <div-card bg='#242424' padding='3vw' margin="0 0 3vw 0" v-for="(item, index) in list" :key="index">
          <div class="head" v-if="active == 0" @click="router(`licailog?id=${item.id}`)">
            <span>{{ item.created_at }}</span>
            <span>
              {{ $t('理财中') }}
              <van-icon name="arrow" color="#CEB082" size="14" />
            </span>
          </div>
          <van-divider style="margin:4vw 0" v-if="active == 0" />

          <div class="item">
            <img :src="item.level.img[0].url" v-if="item.level && item.level.img[0] && item.level.img[0].url" alt="">
            <div class="top">
              <div class="top1">{{ item.level_name }}</div>
              <div class="top2">{{ item.end_time }} {{ $t('到期') }}</div>
            </div>
          </div>
          <van-divider style="margin:4vw 0" />
          <div-padding padding='0vw'>
            <div-flex>
              <div>
                <div-text color='#999999' size='3.5vw' center>{{ $t('已收益') }}</div-text>
                <div-height height='1vw' />
                <div-text color='#CEB082' size='4vw' center>{{ item.already_profit }}</div-text>
              </div>
              <div>
                <div-text color='#999999' size='3.5vw' center>{{ $t('每日收益') }}</div-text>
                <div-height height='1vw' />
                <div-text color='#CEB082' size='4vw' center>{{ item.every_profit }}</div-text>
              </div>
              <div>
                <div-text color='#999999' size='3.5vw' center>{{ $t('到期收益') }}</div-text>
                <div-height height='1vw' />
                <div-text color='#CEB082' size='4vw' center>{{ item.profit }}ACT</div-text>
              </div>
            </div-flex>
            <p style="width: 100%;height: 10px;"></p>
            <div-flex>
              <div>
                <div-text color='#999999' size='3.5vw' center>{{ $t('周期') }}</div-text>
                <div-height height='1vw' />
                <div-text color='#CEB082' size='4vw' center>{{ item.cycle }}{{ $t('天') }}</div-text>
              </div>
              <div>
                <div-text color='#999999' size='3.5vw' center>{{ $t('理财收益率') }}</div-text>
                <div-height height='1vw' />
                <div-text color='#CEB082' size='4vw' center>{{ item.rate }}%</div-text>
              </div>
              <div>
                <div-text color='#999999' size='3.5vw' center>{{ $t('理财金额') }}</div-text>
                <div-height height='1vw' />
                <div-text color='#CEB082' size='4vw' center>{{ item.amount }}ACT</div-text>
              </div>
            </div-flex>
          </div-padding>
        </div-card>
      </div-padding>
    </vant-up-down>
  </div-box>
</template>

<script>
  export default {
    data() {
      return {
        active: 0,
        list: [],
      }
    },
    created() {
      this.up_down()
    },
    methods: {
      onClick() {
        this.up_down()
      },
    },
  }
</script>
<style lang='less' scoped>
  .head {
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    span {
      &:nth-child(2) {
        color: #CEB082;
      }
    }
  }
  .item {
    width: 100%;
    background: #242424;
    border-radius: 6px;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    img {
      width: 12vw;
      height: 12vw;
      border-radius: 5px;
      margin-right: 3vw;
    }
    .top {
      width: 83%;
      .top1 {
        font-size: 16px;
        color: #fff;
        font-weight: 550;
      }
      .top2 {
        font-size: 13px;
        color: #fff;
        margin-top: 4px;
      }
    }
  }
</style>